import { AgentChatMessageDto } from '../models/agent-chat.interfaces';

export function formatMessageTime(createdAt: string): string {
  return new Date(createdAt).toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });
}

/** Divider text for a thread day: Today / Yesterday / weekday within a week / short date beyond. */
export function formatDayLabel(createdAt: string, now: Date = new Date()): string {
  const date = new Date(createdAt);
  const startOfDay = (value: Date) => new Date(value.getFullYear(), value.getMonth(), value.getDate()).getTime();
  const dayInMs = 24 * 60 * 60 * 1000;
  const daysAgo = Math.round((startOfDay(now) - startOfDay(date)) / dayInMs);

  if (daysAgo <= 0) {
    return 'Today';
  }

  if (daysAgo === 1) {
    return 'Yesterday';
  }

  if (daysAgo < 7) {
    return date.toLocaleDateString(undefined, { weekday: 'long' });
  }

  if (date.getFullYear() === now.getFullYear()) {
    return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
  }

  return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
}

export interface ThreadDay {
  label: string;
  messages: AgentChatMessageDto[];
}

/** Groups an ascending thread into day sections; the divider shows the day only, never the channel. */
export function groupMessagesByDay(messages: AgentChatMessageDto[]): ThreadDay[] {
  const days: ThreadDay[] = [];
  let currentDayKey: string | null = null;

  for (const message of messages) {
    const date = new Date(message.createdAt);
    const dayKey = `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;

    if (dayKey !== currentDayKey) {
      currentDayKey = dayKey;
      days.push({ label: formatDayLabel(message.createdAt), messages: [] });
    }

    days[days.length - 1].messages.push(message);
  }

  return days;
}
